<div class="sidenav-user">
  <div class="d-flex justify-content-between align-items-center">
    <div>
      <a routerLink="pages-profile.html" class="link-reset">
        <img src="assets/images/users/user-2.jpg" alt="user-image"
             class="rounded-circle mb-2 avatar-md">
        <span *ngIf="user" class="sidenav-user-name fw-bold">
          {{ user.persona.nombres }} {{user.persona.paterno}} {{user.persona.materno}}
        </span>
        <span class="fs-12 fw-semibold" data-lang="user-role">{{roles}}</span>
      </a>
    </div>
    <div ngbDropdown [placement]="'bottom-end'">
      <button ngbDropdownToggle
              class="btn btn-link p-0 dropdown-toggle drop-arrow-none link-reset sidenav-user-set-icon">
        <ng-icon name="tablerSettings" size="24" class="align-middle ms-1" />
      </button>

      <div ngbDropdownMenu class="dropdown-menu dropdown-menu-end mt-1">

        <div *ngFor="let item of menuItems">
          <div *ngIf="item.isHeader" class="dropdown-header noti-title">
            <h6 class="text-overflow m-0">{{ item.label }}</h6>
          </div>

          <div *ngIf="item.isDivider" class="dropdown-divider"></div>

          <a *ngIf="!item.isHeader && !item.isDivider && item.url" [routerLink]="item.url" class="dropdown-item" [ngClass]="item.class">
            <ng-icon [name]="item.icon" size="17" class="align-middle d-inline-flex align-items-center me-2"/>
            <span class="align-middle" [innerHTML]="item.label"></span>
          </a>

          <button *ngIf="!item.isHeader && !item.isDivider && item.action"
                  (click)="item.action()"
                  class="dropdown-item"
                  [ngClass]="item.class">
            <ng-icon [name]="item.icon" size="17" class="align-middle d-inline-flex align-items-center me-2"/>
            <span class="align-middle" [innerHTML]="item.label"></span>
          </button>
        </div>

      </div>
    </div>
  </div>
</div>
